const mqtt = require('./mqtt.config')
module.exports = {
  ...mqtt,
}



// WEBPACK FOOTER //
// ./src/config/index.js